import styled from "styled-components"

export const Holder = styled.div`
  width: 100%;
  height: 100%;
  user-select: none;
  pointer-events: none;
  position: relative;
`
export const PicPivot = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  width: 65%;
  transform: translate(-50%, -50%);
`
export const PicHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
export const Pic = styled.img`
  width: 100%;
`
export const Overlay = styled.div`
  position: absolute;
  bottom: 3vw;
  left: 2vw;
  transform: translate(0, 100%);
  z-index: 1;
`
export const TitleHolder = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ffffff;
  font-family: "Lora-Regular";
  font-size: 3vw;
  letter-spacing: 0.2em;
  line-height: 98%;
  padding-bottom: 0.7em;
  color: #ffffff;
`
export const Tip = styled.div`
  width: fit-content;
  padding-top: 2em;
  font-style: normal;
  font-weight: 600;
  font-size: 1vw;
  letter-spacing: 0.17em;
  color: #3b1a53;
`
